exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:Arial}.tab{overflow:hidden;border:1px solid #ccc;background-color:transparent}.tab button{background-color:inherit;float:left;border:none;outline:none;cursor:pointer;padding:14px 16px;transition:.3s;font-size:17px}.tab button:hover{background-color:#55988d}.tab button.active{background-color:#f59019}.tabcontent{display:none;padding:6px 12px;border:1px solid #214652;border-top:none}.text-orange{color:#f59019}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ce7fcac","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/GrayZone/aboutYou.vue
// module id = 765
// module chunks = 0